import { render } from "./phoneComponent.vue?vue&type=template&id=95b8cc96"
import script from "./phoneComponent.vue?vue&type=script&lang=js"
export * from "./phoneComponent.vue?vue&type=script&lang=js"

import "./phoneComponent.vue?vue&type=style&index=0&id=95b8cc96&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__